import {Databases, Query} from "appwrite";
import {client, database_id} from "../lib/appwrite";
import {FinalGeneralInfoItem, GeneralInfoItem} from "../types/generalInfo";
import {v4 as uuidv4} from "uuid";

const COLLECTION_ID = "68724bec001974f4f66f"

const databases = new Databases(client);

export const generalInfoService = {

  async list(queries: string[] = [], limit: number = 100): Promise<FinalGeneralInfoItem[]> {
    try {
      const response = await databases.listDocuments(
        database_id,
        COLLECTION_ID,
        [
          Query.limit(limit),
          ...queries
        ]
      );
      const items = response.documents.map(doc => doc as unknown as FinalGeneralInfoItem);
      return items;
    } catch (error) {
      throw error;
    }
  },

  async create(data: FinalGeneralInfoItem): Promise<GeneralInfoItem> {
    try {
      const createdItem = await databases.createDocument(
        database_id,
        COLLECTION_ID,
        uuidv4(),
        data
      ) as unknown as GeneralInfoItem;

      return createdItem;
    } catch (error) {
      throw error;
    }
  },

  async update(data: GeneralInfoItem): Promise<GeneralInfoItem> {
    try {
      const id = data.$id as string
      const {$id, ...correctData} = data
      const updatedItem = await databases.updateDocument(
        database_id,
        COLLECTION_ID,
        id,
        correctData
      ) as unknown as GeneralInfoItem;
      return updatedItem;
    } catch (error) {
      throw error;
    }
  },

  async getById(id: string): Promise<FinalGeneralInfoItem> {
    try {
      const data = await databases.getDocument(
        database_id,
        COLLECTION_ID,
        id
      ) as unknown as FinalGeneralInfoItem;
      return data
    } catch (error) {
      throw error;
    }
  },

  async delete(id: string): Promise<void> {
    try {
      await databases.deleteDocument(
        database_id,
        COLLECTION_ID,
        id
      );
    } catch (error) {
      throw error;
    }
  },

}